import axios from "axios";

// Subscription API calls
export const subscriptionAPI = {
  
  // Get all subscriptions with pagination and filtering
  getAllSubscriptions: async (params = {}) => {
    const response = await axios.get("/api/subscriptions", { params });
    return response.data;
  },

  // Get subscription by ID
  getSubscriptionById: async (id) => {
    const response = await axios.get(`/subscriptions/${id}`);
    return response.data;
  },

  // Create new subscription
  createSubscription: async (subscriptionData) => {
    const response = await axios.post("/subscriptions", subscriptionData);
    return response.data;
  },

  // Update subscription status
  updateSubscriptionStatus: async (id, status, reason = "") => {
    const response = await axios.put(`/subscriptions/${id}/status`, {
      status,
      reason
    });
    return response.data;
  },

  // Process subscription renewal
  processRenewal: async (id) => {
    const response = await axios.post(`/subscriptions/${id}/renewal`);
    return response.data;
  },

  // Get subscription transactions
  getSubscriptionTransactions: async (id, params = {}) => {
    const response = await axios.get(`/subscriptions/${id}/transactions`, {
      params
    });
    return response.data;
  },

  // Get subscription analytics
  getSubscriptionAnalytics: async (params = {}) => {
    const response = await axios.get("/api/subscriptions/analytics", { params });
    return response.data;
  },

  // Get user subscriptions
  getUserSubscriptions: async (userId, params = {}) => {
    const response = await axios.get(`/api/subscriptions/user/${userId}`, { params });
    return response.data;
  },

  // Get subscription growth data for charts
  getSubscriptionGrowth: async (period = '12m') => {
    const response = await axios.get("/api/subscriptions/growth", { params: { period } });
    return response.data;
  },

  // Get top products by subscriptions for charts
  getTopProductsBySubscriptions: async (limit = 5) => {
    const response = await axios.get("/api/subscriptions/top-products", { params: { limit } });
    return response.data;
  }
};

// Transaction API calls
export const transactionAPI = {
  
  // Get all transactions with comprehensive filtering and pagination
  getAllTransactions: async (params = {}) => {
    const response = await axios.get("/api/transactions", { params });
    return response.data;
  },

  // Get transaction by ID
  getTransactionById: async (id) => {
    const response = await axios.get(`/api/transactions/${id}`);
    return response.data;
  },

  // Get transaction statistics and counts
  getTransactionStats: async (params = {}) => {
    const response = await axios.get("/api/transactions/stats", { params });
    return response.data;
  },

  // Create new transaction
  createTransaction: async (transactionData) => {
    const response = await axios.post("/api/transactions", transactionData);
    return response.data;
  },

  // Update transaction status
  updateTransactionStatus: async (id, status, reason = "") => {
    const response = await axios.put(`/api/transactions/${id}/status`, {
      status,
      reason
    });
    return response.data;
  },

  // Process transaction refund
  processRefund: async (id, amount = null, reason = "") => {
    const response = await axios.post(`/api/transactions/${id}/refund`, {
      amount,
      reason
    });
    return response.data;
  },

  // Generate transaction receipt
  generateReceipt: async (id) => {
    const response = await axios.get(`/api/transactions/${id}/receipt`);
    return response.data;
  },

  // Export transactions to CSV/Excel
  exportTransactions: async (params = {}) => {
    const response = await axios.get("/api/transactions/export", { 
      params,
      responseType: 'blob' 
    });
    return response.data;
  },

  // Get user transactions
  getUserTransactions: async (userId, params = {}) => {
    const response = await axios.get(`/api/transactions/user/${userId}`, { params });
    return response.data;
  }
};

// Payment API calls (legacy - kept for backward compatibility)
export const paymentAPI = {
  
  // Get all payments/transactions with pagination and filtering
  getAllPayments: async (params = {}) => {
    const response = await axios.get("/payments", { params });
    return response.data;
  },

  // Create payment record
  createPayment: async (paymentData) => {
    const response = await axios.post("/payments", paymentData);
    return response.data;
  }
};

export default {
  subscriptionAPI,
  paymentAPI
};